import { useParams } from "react-router-dom";
import { FieldInput } from "src/components/ui/FieldInput";
import { OrgScopedBaseUser } from "src/stores/models/user";
import { QualityEventField, QualityEventValue } from "src/types/quality-events";
import { QualityEventFieldValue } from "./QualityEventFieldValue";
import {
  QualityEventDeviceField,
  QualityEventDocumentReferenceInput,
} from "./QualityEventReferenceField";

type QualityEventValueField = Exclude<
  QualityEventField,
  { type: "approval" | "repeatable" }
>;

type QualityEventValueInputProps = {
  field: QualityEventValueField;
  value: QualityEventValue | undefined;
  users: OrgScopedBaseUser[];
  files: File[];
  existingFiles: { id: string; filename: string }[];
  onChange: (value: QualityEventValue) => void;
  onFiles: (files: File[]) => void;
  disabled: boolean;
  readOnly?: boolean;
  required: boolean;
  outstanding?: string;
  invalid?: boolean;
};

export const QualityEventValueInput = (props: QualityEventValueInputProps) => {
  const { orgId = "" } = useParams();
  const { field, value, users, existingFiles } = props;
  if (field.type === "device" || field.type === "document_reference") {
    const Reference =
      field.type === "device"
        ? QualityEventDeviceField
        : QualityEventDocumentReferenceInput;
    return <Reference {...props} orgId={orgId} />;
  }
  return (
    <FieldInput
      {...props}
      field={{
        ...field,
        type: field.type === "rich_text" ? "textarea" : field.type,
      }}
      value={
        value !== null && typeof value === "object" && !Array.isArray(value)
          ? undefined
          : value
      }
      users={
        field.type === "user"
          ? users.filter((user) =>
              user.organizationMemberships?.some(
                (membership) => membership.activated
              )
            )
          : []
      }
      selectedUser={
        field.type === "user"
          ? users.find((user) => user.id === value)
          : undefined
      }
      savedAttachments={
        <QualityEventFieldValue
          field={field}
          value={value}
          files={existingFiles}
          orgId={orgId}
          users={users}
        />
      }
    />
  );
};
